import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

const IMAGE_SCALE_FACTOR = 1.02;

/**
 * A class with style.
 */
export default class ProductCardMediaStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options object..
	 * @param options.hasHoverImage Has hover image.
	 * @param options.theme Theme.
	 * @param options.isHovered "true" if hovered.
	 * @returns Styles.
	 */
	public static getStyle(options: {
		hasHoverImage: boolean;
		isHovered: boolean;
		theme: ITheme;
	}): string {
		const { motion } = options.theme;
		return css`
			:host {
				display: block;
			}

			.imageLinkWrapper {
				display: flex;
				flex-direction: column;
				flex-grow: 1;
				color: inherit;
				text-decoration: inherit;
				cursor: pointer;
			}

			.imageContainer {
				display: block;
				position: relative;
			}

			.singleImage {
				display: block;
				opacity: ${options.hasHoverImage && options.isHovered ? '0' : '1'};
				transform: ${!options.hasHoverImage && options.isHovered
					? 'scale(' + IMAGE_SCALE_FACTOR + ')'
					: 'none'};
				transition-property: transform;
				transition-duration: ${motion.duration.medium};
				transition-timing-function: ${motion.ease.easy};
			}

			.hoverImage {
				display: block;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: ${options.hasHoverImage && options.isHovered
					? 'translate(-50%, -50%) scale(1)'
					: 'translate(-50%, -50%) scale(0.98)'};
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: center center;
				transition-property: opacity, transform;
				transition-duration: ${motion.duration.medium};
				transition-timing-function: ${motion.ease.easy};
				opacity: ${options.hasHoverImage && options.isHovered ? '1' : '0'};
			}
		`;
	}
}
